var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileVideoOff = function SvgMobileVideoOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.828 24.828"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.414 16.414v1a2 2 0 0 1-2 2h-11a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h2m5.66 0h3.34a2 2 0 0 1 2 2v3.34l1 1 6-4.34v10",
    "data-name": "Path 1066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.414 1.414 22 22",
    "data-name": "Line 14"
  }))));
};
export default SvgMobileVideoOff;